"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: insights.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyMedian = exports.ProvincesResponse_Province = exports.ProvincesResponse = exports.TopCitiesResponse_TopCities = exports.TopCitiesResponse = exports.TopCities = exports.TopNeighbourhood = exports.InsightsResponse = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "domain";
function createBaseInsightsResponse() {
    return {
        topNeighbourhoods: [],
        MedianPurchasePrice: 0,
        MedianRentPrice: 0,
        SellListRatio: 0,
        DaysOnMarket: 0,
        TotalHouses: 0,
        TotalTownhouses: 0,
        TotalCondos: 0,
        AvgHousePrice: 0,
        AvgTownhousePrice: 0,
        AvgCondoPrice: 0,
        AvgTotalPrice: 0,
        AvgRentalPrice: 0,
        AvgPricePerSqft: 0,
        TotalRentals: 0,
        topCities: [],
        medianPriceTrends: [],
    };
}
exports.InsightsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.topNeighbourhoods) {
            exports.TopNeighbourhood.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.MedianPurchasePrice !== 0) {
            writer.uint32(17).double(message.MedianPurchasePrice);
        }
        if (message.MedianRentPrice !== 0) {
            writer.uint32(25).double(message.MedianRentPrice);
        }
        if (message.SellListRatio !== 0) {
            writer.uint32(33).double(message.SellListRatio);
        }
        if (message.DaysOnMarket !== 0) {
            writer.uint32(40).int32(message.DaysOnMarket);
        }
        if (message.TotalHouses !== 0) {
            writer.uint32(48).int32(message.TotalHouses);
        }
        if (message.TotalTownhouses !== 0) {
            writer.uint32(56).int32(message.TotalTownhouses);
        }
        if (message.TotalCondos !== 0) {
            writer.uint32(64).int32(message.TotalCondos);
        }
        if (message.AvgHousePrice !== 0) {
            writer.uint32(73).double(message.AvgHousePrice);
        }
        if (message.AvgTownhousePrice !== 0) {
            writer.uint32(81).double(message.AvgTownhousePrice);
        }
        if (message.AvgCondoPrice !== 0) {
            writer.uint32(89).double(message.AvgCondoPrice);
        }
        if (message.AvgTotalPrice !== 0) {
            writer.uint32(97).double(message.AvgTotalPrice);
        }
        if (message.AvgRentalPrice !== 0) {
            writer.uint32(105).double(message.AvgRentalPrice);
        }
        if (message.AvgPricePerSqft !== 0) {
            writer.uint32(113).double(message.AvgPricePerSqft);
        }
        if (message.TotalRentals !== 0) {
            writer.uint32(120).int32(message.TotalRentals);
        }
        for (const v of message.topCities) {
            exports.TopCities.encode(v, writer.uint32(130).fork()).join();
        }
        for (const v of message.medianPriceTrends) {
            exports.MonthlyMedian.encode(v, writer.uint32(138).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInsightsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.topNeighbourhoods.push(exports.TopNeighbourhood.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 17) {
                        break;
                    }
                    message.MedianPurchasePrice = reader.double();
                    continue;
                }
                case 3: {
                    if (tag !== 25) {
                        break;
                    }
                    message.MedianRentPrice = reader.double();
                    continue;
                }
                case 4: {
                    if (tag !== 33) {
                        break;
                    }
                    message.SellListRatio = reader.double();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.DaysOnMarket = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.TotalHouses = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.TotalTownhouses = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.TotalCondos = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 73) {
                        break;
                    }
                    message.AvgHousePrice = reader.double();
                    continue;
                }
                case 10: {
                    if (tag !== 81) {
                        break;
                    }
                    message.AvgTownhousePrice = reader.double();
                    continue;
                }
                case 11: {
                    if (tag !== 89) {
                        break;
                    }
                    message.AvgCondoPrice = reader.double();
                    continue;
                }
                case 12: {
                    if (tag !== 97) {
                        break;
                    }
                    message.AvgTotalPrice = reader.double();
                    continue;
                }
                case 13: {
                    if (tag !== 105) {
                        break;
                    }
                    message.AvgRentalPrice = reader.double();
                    continue;
                }
                case 14: {
                    if (tag !== 113) {
                        break;
                    }
                    message.AvgPricePerSqft = reader.double();
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.TotalRentals = reader.int32();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.topCities.push(exports.TopCities.decode(reader, reader.uint32()));
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.medianPriceTrends.push(exports.MonthlyMedian.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            topNeighbourhoods: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.top_neighbourhoods)
                ? object.top_neighbourhoods.map((e) => exports.TopNeighbourhood.fromJSON(e))
                : [],
            MedianPurchasePrice: isSet(object.median_purchase_price) ? globalThis.Number(object.median_purchase_price) : 0,
            MedianRentPrice: isSet(object.median_rent_price) ? globalThis.Number(object.median_rent_price) : 0,
            SellListRatio: isSet(object.sell_list_ratio) ? globalThis.Number(object.sell_list_ratio) : 0,
            DaysOnMarket: isSet(object.days_on_market) ? globalThis.Number(object.days_on_market) : 0,
            TotalHouses: isSet(object.total_houses) ? globalThis.Number(object.total_houses) : 0,
            TotalTownhouses: isSet(object.total_townhouses) ? globalThis.Number(object.total_townhouses) : 0,
            TotalCondos: isSet(object.total_condos) ? globalThis.Number(object.total_condos) : 0,
            AvgHousePrice: isSet(object.avg_house_price) ? globalThis.Number(object.avg_house_price) : 0,
            AvgTownhousePrice: isSet(object.avg_townhouse_price) ? globalThis.Number(object.avg_townhouse_price) : 0,
            AvgCondoPrice: isSet(object.avg_condo_price) ? globalThis.Number(object.avg_condo_price) : 0,
            AvgTotalPrice: isSet(object.avg_total_price) ? globalThis.Number(object.avg_total_price) : 0,
            AvgRentalPrice: isSet(object.avg_rental_price) ? globalThis.Number(object.avg_rental_price) : 0,
            AvgPricePerSqft: isSet(object.avg_price_per_sqft) ? globalThis.Number(object.avg_price_per_sqft) : 0,
            TotalRentals: isSet(object.total_rentals) ? globalThis.Number(object.total_rentals) : 0,
            topCities: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.top_cities)
                ? object.top_cities.map((e) => exports.TopCities.fromJSON(e))
                : [],
            medianPriceTrends: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.median_price_trends)
                ? object.median_price_trends.map((e) => exports.MonthlyMedian.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b, _c;
        const obj = {};
        if ((_a = message.topNeighbourhoods) === null || _a === void 0 ? void 0 : _a.length) {
            obj.top_neighbourhoods = message.topNeighbourhoods.map((e) => exports.TopNeighbourhood.toJSON(e));
        }
        if (message.MedianPurchasePrice !== 0) {
            obj.median_purchase_price = message.MedianPurchasePrice;
        }
        if (message.MedianRentPrice !== 0) {
            obj.median_rent_price = message.MedianRentPrice;
        }
        if (message.SellListRatio !== 0) {
            obj.sell_list_ratio = message.SellListRatio;
        }
        if (message.DaysOnMarket !== 0) {
            obj.days_on_market = Math.round(message.DaysOnMarket);
        }
        if (message.TotalHouses !== 0) {
            obj.total_houses = Math.round(message.TotalHouses);
        }
        if (message.TotalTownhouses !== 0) {
            obj.total_townhouses = Math.round(message.TotalTownhouses);
        }
        if (message.TotalCondos !== 0) {
            obj.total_condos = Math.round(message.TotalCondos);
        }
        if (message.AvgHousePrice !== 0) {
            obj.avg_house_price = message.AvgHousePrice;
        }
        if (message.AvgTownhousePrice !== 0) {
            obj.avg_townhouse_price = message.AvgTownhousePrice;
        }
        if (message.AvgCondoPrice !== 0) {
            obj.avg_condo_price = message.AvgCondoPrice;
        }
        if (message.AvgTotalPrice !== 0) {
            obj.avg_total_price = message.AvgTotalPrice;
        }
        if (message.AvgRentalPrice !== 0) {
            obj.avg_rental_price = message.AvgRentalPrice;
        }
        if (message.AvgPricePerSqft !== 0) {
            obj.avg_price_per_sqft = message.AvgPricePerSqft;
        }
        if (message.TotalRentals !== 0) {
            obj.total_rentals = Math.round(message.TotalRentals);
        }
        if ((_b = message.topCities) === null || _b === void 0 ? void 0 : _b.length) {
            obj.top_cities = message.topCities.map((e) => exports.TopCities.toJSON(e));
        }
        if ((_c = message.medianPriceTrends) === null || _c === void 0 ? void 0 : _c.length) {
            obj.median_price_trends = message.medianPriceTrends.map((e) => exports.MonthlyMedian.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.InsightsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        const message = createBaseInsightsResponse();
        message.topNeighbourhoods = ((_a = object.topNeighbourhoods) === null || _a === void 0 ? void 0 : _a.map((e) => exports.TopNeighbourhood.fromPartial(e))) || [];
        message.MedianPurchasePrice = (_b = object.MedianPurchasePrice) !== null && _b !== void 0 ? _b : 0;
        message.MedianRentPrice = (_c = object.MedianRentPrice) !== null && _c !== void 0 ? _c : 0;
        message.SellListRatio = (_d = object.SellListRatio) !== null && _d !== void 0 ? _d : 0;
        message.DaysOnMarket = (_e = object.DaysOnMarket) !== null && _e !== void 0 ? _e : 0;
        message.TotalHouses = (_f = object.TotalHouses) !== null && _f !== void 0 ? _f : 0;
        message.TotalTownhouses = (_g = object.TotalTownhouses) !== null && _g !== void 0 ? _g : 0;
        message.TotalCondos = (_h = object.TotalCondos) !== null && _h !== void 0 ? _h : 0;
        message.AvgHousePrice = (_j = object.AvgHousePrice) !== null && _j !== void 0 ? _j : 0;
        message.AvgTownhousePrice = (_k = object.AvgTownhousePrice) !== null && _k !== void 0 ? _k : 0;
        message.AvgCondoPrice = (_l = object.AvgCondoPrice) !== null && _l !== void 0 ? _l : 0;
        message.AvgTotalPrice = (_m = object.AvgTotalPrice) !== null && _m !== void 0 ? _m : 0;
        message.AvgRentalPrice = (_o = object.AvgRentalPrice) !== null && _o !== void 0 ? _o : 0;
        message.AvgPricePerSqft = (_p = object.AvgPricePerSqft) !== null && _p !== void 0 ? _p : 0;
        message.TotalRentals = (_q = object.TotalRentals) !== null && _q !== void 0 ? _q : 0;
        message.topCities = ((_r = object.topCities) === null || _r === void 0 ? void 0 : _r.map((e) => exports.TopCities.fromPartial(e))) || [];
        message.medianPriceTrends = ((_s = object.medianPriceTrends) === null || _s === void 0 ? void 0 : _s.map((e) => exports.MonthlyMedian.fromPartial(e))) || [];
        return message;
    },
};
function createBaseTopNeighbourhood() {
    return { name: "", count: 0 };
}
exports.TopNeighbourhood = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.count !== 0) {
            writer.uint32(16).int32(message.count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTopNeighbourhood();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.count = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            count: isSet(object.count) ? globalThis.Number(object.count) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        return obj;
    },
    create(base) {
        return exports.TopNeighbourhood.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTopNeighbourhood();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.count = (_b = object.count) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseTopCities() {
    return { name: "", count: 0 };
}
exports.TopCities = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.count !== 0) {
            writer.uint32(16).int32(message.count);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTopCities();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.count = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            count: isSet(object.count) ? globalThis.Number(object.count) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        return obj;
    },
    create(base) {
        return exports.TopCities.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTopCities();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.count = (_b = object.count) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseTopCitiesResponse() {
    return { topCities: [] };
}
exports.TopCitiesResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.topCities) {
            exports.TopCitiesResponse_TopCities.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTopCitiesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.topCities.push(exports.TopCitiesResponse_TopCities.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            topCities: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.top_cities)
                ? object.top_cities.map((e) => exports.TopCitiesResponse_TopCities.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.topCities) === null || _a === void 0 ? void 0 : _a.length) {
            obj.top_cities = message.topCities.map((e) => exports.TopCitiesResponse_TopCities.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.TopCitiesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseTopCitiesResponse();
        message.topCities = ((_a = object.topCities) === null || _a === void 0 ? void 0 : _a.map((e) => exports.TopCitiesResponse_TopCities.fromPartial(e))) || [];
        return message;
    },
};
function createBaseTopCitiesResponse_TopCities() {
    return { Name: "", Slug: "", Province: "", TotalCount: 0, SaleCount: 0, RentCount: 0 };
}
exports.TopCitiesResponse_TopCities = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.Name !== "") {
            writer.uint32(10).string(message.Name);
        }
        if (message.Slug !== "") {
            writer.uint32(18).string(message.Slug);
        }
        if (message.Province !== "") {
            writer.uint32(26).string(message.Province);
        }
        if (message.TotalCount !== 0) {
            writer.uint32(32).int32(message.TotalCount);
        }
        if (message.SaleCount !== 0) {
            writer.uint32(40).int32(message.SaleCount);
        }
        if (message.RentCount !== 0) {
            writer.uint32(48).int32(message.RentCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTopCitiesResponse_TopCities();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.Name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.Slug = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.Province = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.TotalCount = reader.int32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.SaleCount = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.RentCount = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            Name: isSet(object.name) ? globalThis.String(object.name) : "",
            Slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            Province: isSet(object.province) ? globalThis.String(object.province) : "",
            TotalCount: isSet(object.total_count) ? globalThis.Number(object.total_count) : 0,
            SaleCount: isSet(object.sale_count) ? globalThis.Number(object.sale_count) : 0,
            RentCount: isSet(object.rent_count) ? globalThis.Number(object.rent_count) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.Name !== "") {
            obj.name = message.Name;
        }
        if (message.Slug !== "") {
            obj.slug = message.Slug;
        }
        if (message.Province !== "") {
            obj.province = message.Province;
        }
        if (message.TotalCount !== 0) {
            obj.total_count = Math.round(message.TotalCount);
        }
        if (message.SaleCount !== 0) {
            obj.sale_count = Math.round(message.SaleCount);
        }
        if (message.RentCount !== 0) {
            obj.rent_count = Math.round(message.RentCount);
        }
        return obj;
    },
    create(base) {
        return exports.TopCitiesResponse_TopCities.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseTopCitiesResponse_TopCities();
        message.Name = (_a = object.Name) !== null && _a !== void 0 ? _a : "";
        message.Slug = (_b = object.Slug) !== null && _b !== void 0 ? _b : "";
        message.Province = (_c = object.Province) !== null && _c !== void 0 ? _c : "";
        message.TotalCount = (_d = object.TotalCount) !== null && _d !== void 0 ? _d : 0;
        message.SaleCount = (_e = object.SaleCount) !== null && _e !== void 0 ? _e : 0;
        message.RentCount = (_f = object.RentCount) !== null && _f !== void 0 ? _f : 0;
        return message;
    },
};
function createBaseProvincesResponse() {
    return { provinces: [] };
}
exports.ProvincesResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.provinces) {
            exports.ProvincesResponse_Province.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProvincesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.provinces.push(exports.ProvincesResponse_Province.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            provinces: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.provinces)
                ? object.provinces.map((e) => exports.ProvincesResponse_Province.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.provinces) === null || _a === void 0 ? void 0 : _a.length) {
            obj.provinces = message.provinces.map((e) => exports.ProvincesResponse_Province.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ProvincesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseProvincesResponse();
        message.provinces = ((_a = object.provinces) === null || _a === void 0 ? void 0 : _a.map((e) => exports.ProvincesResponse_Province.fromPartial(e))) || [];
        return message;
    },
};
function createBaseProvincesResponse_Province() {
    return { Province: "", TotalCount: 0, SaleCount: 0, RentCount: 0 };
}
exports.ProvincesResponse_Province = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.Province !== "") {
            writer.uint32(10).string(message.Province);
        }
        if (message.TotalCount !== 0) {
            writer.uint32(16).int32(message.TotalCount);
        }
        if (message.SaleCount !== 0) {
            writer.uint32(24).int32(message.SaleCount);
        }
        if (message.RentCount !== 0) {
            writer.uint32(32).int32(message.RentCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseProvincesResponse_Province();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.Province = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.TotalCount = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.SaleCount = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.RentCount = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            Province: isSet(object.province) ? globalThis.String(object.province) : "",
            TotalCount: isSet(object.total_count) ? globalThis.Number(object.total_count) : 0,
            SaleCount: isSet(object.sale_count) ? globalThis.Number(object.sale_count) : 0,
            RentCount: isSet(object.rent_count) ? globalThis.Number(object.rent_count) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.Province !== "") {
            obj.province = message.Province;
        }
        if (message.TotalCount !== 0) {
            obj.total_count = Math.round(message.TotalCount);
        }
        if (message.SaleCount !== 0) {
            obj.sale_count = Math.round(message.SaleCount);
        }
        if (message.RentCount !== 0) {
            obj.rent_count = Math.round(message.RentCount);
        }
        return obj;
    },
    create(base) {
        return exports.ProvincesResponse_Province.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseProvincesResponse_Province();
        message.Province = (_a = object.Province) !== null && _a !== void 0 ? _a : "";
        message.TotalCount = (_b = object.TotalCount) !== null && _b !== void 0 ? _b : 0;
        message.SaleCount = (_c = object.SaleCount) !== null && _c !== void 0 ? _c : 0;
        message.RentCount = (_d = object.RentCount) !== null && _d !== void 0 ? _d : 0;
        return message;
    },
};
function createBaseMonthlyMedian() {
    return { date: "", docCount: 0, medianPrice: 0 };
}
exports.MonthlyMedian = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.date !== "") {
            writer.uint32(10).string(message.date);
        }
        if (message.docCount !== 0) {
            writer.uint32(16).int32(message.docCount);
        }
        if (message.medianPrice !== 0) {
            writer.uint32(25).double(message.medianPrice);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMonthlyMedian();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.date = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.docCount = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 25) {
                        break;
                    }
                    message.medianPrice = reader.double();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            date: isSet(object.date) ? globalThis.String(object.date) : "",
            docCount: isSet(object.doc_count) ? globalThis.Number(object.doc_count) : 0,
            medianPrice: isSet(object.median_price) ? globalThis.Number(object.median_price) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.date !== "") {
            obj.date = message.date;
        }
        if (message.docCount !== 0) {
            obj.doc_count = Math.round(message.docCount);
        }
        if (message.medianPrice !== 0) {
            obj.median_price = message.medianPrice;
        }
        return obj;
    },
    create(base) {
        return exports.MonthlyMedian.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseMonthlyMedian();
        message.date = (_a = object.date) !== null && _a !== void 0 ? _a : "";
        message.docCount = (_b = object.docCount) !== null && _b !== void 0 ? _b : 0;
        message.medianPrice = (_c = object.medianPrice) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=insights.js.map